export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const STATUS_OPTIONS = ['new', 'confirmed', 'completed', 'cancelled'];

export const STATUS_COLORS = {
  new: 'bg-[#c9a961]/15 text-[#8a7132] border-[#c9a961]/40',
  confirmed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  completed: 'bg-slate-100 text-slate-700 border-slate-300',
  cancelled: 'bg-rose-50 text-rose-700 border-rose-200',
};

export const WINDOW_LABEL = {
  morning: 'Morning · 8:30–11 AM',
  midday: 'Midday · 11 AM – 1:30 PM',
  afternoon: 'Afternoon · 1:30–3:30 PM',
  evening: 'Late Afternoon · 3:30–5 PM',
};

export const WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
export const WEEKDAYS_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

export const authHeaders = (token) => ({ headers: { 'X-Admin-Token': token } });

export const fmtDate = (d) => {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  } catch { return d; }
};

export const fmtDateTime = (d) => {
  if (!d) return '—';
  try {
    return new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
  } catch { return d; }
};
